import React, { Dispatch, SetStateAction } from "react";
import Navigator from './components/Navigation';
import { ArticleTextSection } from "./articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "./articleDetailPage/ArticleTitle";
import './style.css';
import { Wavedivider } from "./components/Wavedivider";
import { useMetaTags } from './utils/useMetaTags';

function PageAboutHistory(props: {
    activeNav: number,
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      useMetaTags({
        title: 'About History - Lynkim',
        description: 'About History',
        image: '/ogimage.png',
      });

      return (
        <>
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'이전 기록들'}
                titleEn={'Past Records'}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
            <ArticleTextSection
                marginBottom={true}
                title={<div>2026.05.17.</div>}
                swapByLanguage={true}
                description={<div>
                  세상의 온갖 재미를 많은 사람들과 함께 느끼며 살아가는 목표로 살고 있어요.
                    Product Designer로 일하고 있어요. 최근 금융업에서 새로운 도전을 시작했어요.
                    멘탈헬스케어, 커뮤니티, 커머스, 광고와 오프라인 주문/결제 도메인을 경험했고, 전문가가 사용할 수 있는 툴 서비스를 디자인하는 것에 더 많은 관심을 갖고 있어요.
                    최근 당구와 탁구의 매력을 알게 되었고, 펜싱과 피겨스케이팅을 좋아하지만 잠시 쉬어가고 있어요.
                    다양한 엔터테인먼트에 관련된 것에서 기획하는 것을 좋아하고, 직접 보드게임을 만들고 있어요.
                    이제 막 피어난 새싹과 막바지에 화려하게 물든 단풍을 보는 것을 좋아해요.
                    지금은 이전의 모습에서 벗어나, 완전히 다른 새로운 삶을 살아가보려고 시도하고 있어요.
                  </div> }
                subDescription={<div>
                    I live with the goal of experiencing all the fun the world has to offer, alongside many people.
                    I work as a Product Designer. Recently I started a new challenge in the finance industry.
                    I've worked across mental healthcare, community, commerce, advertising, and offline order/payment domains, and I'm especially interested in designing tools for professionals.
                    I've recently discovered the appeal of billiards and table tennis. I love fencing and figure skating but am taking a short break from them.
                    I love planning things related to various forms of entertainment, and I'm currently making a board game.
                    I love watching freshly sprouted new buds, and the brilliantly colored autumn leaves at the very end of the season.
                    Right now, I'm trying to break away from who I used to be and live a completely different new life.
                  </div> }
            />
            <ArticleTextSection
                marginBottom={true}
                marginTop={true}
                title={<div>2026.03.23.</div>}
                swapByLanguage={true}
                description={<div>
                  Product Designer로서 당근에서 소상공인을 위한 광고 플랫폼과 광고 상품을 디자인했고, 오프라인과 온라인을 연결하는 QR오더 제품을 만들었습니다.
                  두뇌 서바이벌 예능을 즐겨 보고 사람들과 함께 게임하는 것을 좋아해요.
                  서바이벌이나 두뇌 게임 프로그램을 기획하는 것도 좋아하고, 직접 보드게임을 만들고 있어요.
                  당구, 프리스비, 펜싱을 가끔 즐기고, 요즘은 피겨스케이팅을 다시 시작했습니다.
                  세상의 온갖 재미를 모두 느끼며 살아가는 목표로 살고 있어요.</div> }
                subDescription={<div>
                  As a Product Designer at Daangn, I designed an advertising platform and ad products for small business owners, and built a QR Order product connecting offline and online.
                  I love watching brain-survival variety shows and playing games with people.
                  I also love designing survival and brain-game programs, and I'm currently making a board game.
                  I occasionally enjoy billiards, frisbee, and fencing, and these days I've started figure skating again.
                  I live with the goal of experiencing every kind of fun the world has to offer.</div> }
            />
        </div>
        </>
      )
  }

export default PageAboutHistory;
